import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App.js';
import './styles/index.css';
import { installGlobalTheme } from './styles/theme.js';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element #root not found.');
}

installGlobalTheme();

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
